import * as React from 'react';
import { Link } from 'react-router-dom';

import { LazyImage } from './LazyImage';

import orqaLogo from '../assets/images/orqa-logo.png';

export const Footer: React.FC = () => (
  <footer className="footer" role="contentinfo">
    <div className="wrapper">
      <div className="footer__container">
        <span className="footer__line" />
        <section className="footer__branding">
          <Link
            to="/"
            title="Open ORQA Homepage"
            onClick={() => window.scrollTo(0, 0)}
          >
            <LazyImage src={orqaLogo} alt="Company's Logo" height={50} />
          </Link>
          <p className="footer__description">
            High End equipment for FPV drones.
          </p>
          <img
            src={require('main/assets/images/iso-9001-certificate.webp')}
            alt="ISO 9001 certificate"
            className="footer__certificate"
          />
        </section>

        <section className="footer__section footer__reseller">
          <div>
            <h2 className="t-tiny t-upperext o-40 s-bottom--lrg">Resellers</h2>
          </div>
          <div>
            <Link
              to="/resellers"
              className="t-zeta"
              rel="nofollow"
              style={{ lineHeight: '140%' }}
            >
              List of resellers
            </Link>
          </div>
        </section>
        <section className="footer__section footer__resources">
          <div>
            <h2 className="t-tiny t-upperext o-40 s-bottom--lrg">Resources</h2>
          </div>
          <div>
            <div>
              <Link
                to="/downloads"
                className="t-zeta"
                style={{ lineHeight: '140%' }}
              >
                Downloads
              </Link>
            </div>
            <div>
              <Link
                to="/manual"
                className="t-zeta"
                style={{ lineHeight: '140%' }}
              >
                Documentation
              </Link>
            </div>
            <div>
              <Link
                to="/news/"
                className="t-zeta"
                style={{ lineHeight: '140%' }}
              >
                News
              </Link>
            </div>
          </div>
        </section>
        <section className="footer__section footer__support">
          <div>
            <h2 className="t-tiny t-upperext o-40 s-bottom--lrg">Support</h2>
          </div>
          <div>
            <a
              href="https://orqafpv.freshdesk.com/support/solutions"
              target="_blank"
              rel="noopener noreferrer nofollow"
              style={{ lineHeight: '140%' }}
              onMouseDown={event => event.preventDefault()}
            >
              Support
            </a>
          </div>
          <div>
            <p
              className="t-zeta submit-ticket-link"
              onMouseDown={event => event.preventDefault()}
              onClick={() => (window as any).FreshworksWidget('open')}
              style={{ cursor: 'pointer', lineHeight: '140%' }}
            >
              Submit ticket
            </p>
          </div>
          <div>
            <Link
              to="/privacy-policy"
              className="t-zeta"
              rel="nofollow"
              style={{ lineHeight: '140%' }}
            >
              Privacy Policy
            </Link>
          </div>
        </section>

        <section className="footer__section footer__info">
          <div>
            <h2 className="t-tiny t-upperext o-40 s-bottom--lrg">More</h2>
          </div>
          <div>
            <Link
              to="/enterprise"
              className="t-zeta"
              style={{ lineHeight: '140%' }}
            >
              Enterprise
            </Link>
          </div>
          <div>
            <Link to="/jobs" className="t-zeta" style={{ lineHeight: '140%' }}>
              Jobs
            </Link>
          </div>
        </section>
        <section className="footer__section">
          <div>
            <h2 className="t-tiny t-upperext o-40 s-bottom--lrg t-nowrap">
              EU Projects
            </h2>
          </div>
          <div>
            <Link
              to="/eu-projects/esif"
              className="t-zeta"
              rel="nofollow"
              style={{ lineHeight: '140%' }}
            >
              <span className="t-upper">Esif</span> financial instruments
            </Link>
            <Link
              to="/eu-projects/eu-Internacionalizacija"
              className="t-zeta"
              rel="nofollow"
              style={{ lineHeight: '140%' }}
            >
              Internationalization of ORQA solutions
            </Link>
            <Link
              to="/eu-projects/eu-razvojna-ispitivanja"
              className="t-zeta"
              rel="nofollow"
              style={{ lineHeight: '140%' }}
            >
              Development testing on Orqa Microdron and Orqa Drone Soccer drones
            </Link>
            <Link
              to="/eu-projects/eu-kiberneticka-sigurnost"
              className="t-zeta"
              rel="nofollow"
              style={{ lineHeight: '140%' }}
            >
              Cybersecurity Voucher
            </Link>
            <Link
              to="/eu-projects/eu-bodycam-bluetooth"
              className="t-zeta"
              rel="nofollow"
              style={{ lineHeight: '140%' }}
            >
              Development testing of Orqa BodyCam and Bluetooth module products
            </Link>
            <Link
              to="/eu-projects/eu-1s-charger"
              className="t-zeta"
              rel="nofollow"
              style={{ lineHeight: '140%' }}
            >
              Development testing of the 1S Charger
            </Link>
          </div>
        </section>
      </div>
    </div>
    <div
      className="wrapper footer__zicer"
      style={{ display: 'flex', gap: '48px' }}
    >
      <LazyImage
        className="footer__zicer-logo eec-logo"
        src={require('main/assets/images/EEC-logo.png')}
        alt="ZICER logo"
      />
    </div>
    <div className="wrapper">
      <section className="footer__copy">
        <p className="t-zeta">
          Copyright © {new Date().getFullYear()} Orqa Ltd. All rights reserved.
        </p>
      </section>
    </div>
  </footer>
);
